import { faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Grid from '@material-ui/core/Grid'
import React from 'react'
import styled from 'styled-components'

export const Overlay = styled.div`
  position: absolute;
  background: ${({ theme }) => theme.colors.grayscale.white}ea;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  cursor: not-allowed;
  padding-left: 15px;
  padding-right: 15px;
`

export const DisabledOverlayContainer = styled.div`
  display: flex;
  align-items: flex-start;
`

export const DisabledOverlayIcon = styled(FontAwesomeIcon)`
  ${({ theme }) => theme.typography.body2};
  margin-bottom: 0;
  margin-right: 8px;
`

export const DisabledOverlayMessage = styled.p`
  ${({ theme }) => theme.typography.body2};
  margin-bottom: 0;
  max-width: 26em;
  text-align: center;
`
export const DisabledOverlay: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Overlay>
    <DisabledOverlayContainer>
      <Grid item>
        <DisabledOverlayIcon icon={faCircleInfo} />
      </Grid>
      <Grid item>
        <DisabledOverlayMessage>{children}</DisabledOverlayMessage>
      </Grid>
    </DisabledOverlayContainer>
  </Overlay>
)
